"use client"

import { Children, cloneElement } from 'react';

import { useMenuContext } from './MenuProvider';

import type { FC, ReactElement } from 'react';

export interface ToggleProps {
  children: ReactElement;
}

export const MenuHoverLeave: FC<ToggleProps> = ({ children }) => {
  const { onMouseLeave, open } = useMenuContext();

  return (
    <>
      {Children.map(
        children,
        (child): ReactElement =>
          cloneElement(child, {
            onMouseLeave,
            'aria-controls': open ? 'menu' : void 0,
            'aria-haspopup': 'true',
            'aria-expanded': open ? 'true' : void 0,
          })
      )}
    </>
  );
};
